import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "menu-empty" }
const _hoisted_2 = { class: "tabs" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 0,
  class: "tab-content"
}
const _hoisted_5 = { class: "menu-list" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 1,
  class: "tab-report"
}
const _hoisted_8 = { class: "form" }
const _hoisted_9 = { class: "form" }
const _hoisted_10 = { class: "form" }
const _hoisted_11 = { class: "form" }
const _hoisted_12 = { class: "form-avatar" }
const _hoisted_13 = { class: "form" }

import { computed, onMounted, ref, watch } from "vue";
import { useI18n } from "vue-i18n";
import debounce from "lodash-es/debounce";
import set from "lodash-es/set";

import { toast } from "@/common/utils/toast";

import type { ReportType } from "@/common/types/report";
import type { AvatarType } from "@/common/types/common";

import {
  fileAvatarFileShow,
  fileAvatarCreate,
  fileAvatarUpdate,
  fileAvatarDelete,
} from "@/common/api/rest/file/avatar";

// components
import {
  baseAccordion,
  baseAvatar,
  baseConfirm,
  baseInput,
  baseSelect,
  baseTextarea,
  baseTextEditor,
} from "@/common/components";


export default /*@__PURE__*/_defineComponent({
  __name: 'empty',
  props: {
    report: {}
  },
  emits: ["click:menu", "report:update", "report:reload"],
  setup(__props: any, { emit: __emit }) {

const { t } = useI18n();

const emit = __emit;

const props = __props;

const payload = ref({
  front_cover: {
    visible: 0,
    font_family: "Verdana",
    align: "left",
    size: "16px",
    text: "",
  },
  header: {
    visible: 0,
    title: "",
    subtitle: "",
  },
  footer: {
    visible: 0,
    title: "",
    subtitle: "",
  },
  summary: {
    visible: 0,
    font_family: "Verdana",
    size: "16px",
  },
  name: "",
  description: "",
});

const selectedTab = ref<string>("content");
const selectedAcc = ref<string>("infos");

const mounted = ref(false);
const showDelAvatar = ref(false);

const avatar = computed(() => props.report?.avatar);

const showOptions = computed(() => [
  {
    option: "Sim",
    value: 1,
  },
  {
    option: "Não",
    value: 0,
  },
]);

const optionsFonts = computed(() => [
  { option: "Arial", value: "Arial" },
  { option: "Calibri", value: "Calibri" },
  { option: "Courier", value: "Courier" },
  { option: "Georgia", value: "Georgia" },
  { option: "Open Sans", value: "Open Sans" },
  { option: "Sans Serif", value: "sans-serif" },
  { option: "Times New Roman", value: "Times New Roman" },
  { option: "Verdana", value: "Verdana" },
]);

const optionsFontSize = computed(() => [
  { option: "10px", value: "10px" },
  { option: "11px", value: "11px" },
  { option: "12px", value: "12px" },
  { option: "13px", value: "13px" },
  { option: "14px", value: "14px" },
  { option: "15px", value: "15px" },
  { option: "16px", value: "16px" },
  { option: "17px", value: "17px" },
  { option: "18px", value: "18px" },
  { option: "20px", value: "20px" },
  { option: "22px", value: "22px" },
  { option: "24px", value: "24px" },
  { option: "26px", value: "26px" },
  { option: "28px", value: "28px" },
  { option: "30px", value: "30px" },
]);

const optionsAlign = computed(() => [
  { option: "Esquerda", value: "left" },
  { option: "Centro", value: "center" },
  { option: "Direita", value: "right" },
  { option: "Justificado", value: "justify" },
]);

const menuList = computed(() => {
  return [
    {
      key: "add",
      label: "Adicionar Bloco",
    },
  ];
});

const tabList = computed(() => [
  {
    key: "content",
    label: "Conteúdo",
  },
  {
    key: "report",
    label: "Relatório",
  },
]);

function toggleAccordion(key: string) {
  selectedAcc.value = selectedAcc.value === key ? "" : key;
}

function onUpdate(key: keyof typeof payload.value) {
  if (
    key === "header" ||
    key === "footer" ||
    key === "front_cover" ||
    key === "summary"
  ) {
    emit("report:update", {
      [key]: JSON.stringify(payload.value[key]),
    });

    return;
  }

  emit("report:update", {
    [key]: payload.value[key],
  });
}

function onUpdateEditor(
  key: keyof typeof payload.value,
  field: string,
  value: string,
) {
  set(payload.value, `${key}.${field}`, value);

  onUpdate(key);
}

function addAvatar(file: string) {
  fileAvatarCreate(props.report.account_id, {
    owner_id: props.report.report_id,
    type: "avatar",
    file: file,
  })
    .then((response) => {
      const { success, message } = response;

      if (success) {
        emit("report:reload");
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    })
    .finally(() => {
      onUpdate("header");
    });
}

function updateAvatar(file: string) {
  if (!avatar.value) return;

  fileAvatarUpdate(props.report.account_id, avatar.value.avatar_id, { file })
    .then((response) => {
      const { success, message } = response;

      if (success) {
        emit("report:reload");
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    })
    .finally(() => {
      onUpdate("header");
    });
}

function changeAvatar(file: string) {
  if (!avatar.value) {
    addAvatar(file);
  } else {
    updateAvatar(file);
  }
}

function delAvatar() {
  showDelAvatar.value = true;
}

function delAvatarConfirm() {
  if (!avatar.value) return;

  fileAvatarDelete(props.report.account_id, avatar.value.avatar_id)
    .then((response) => {
      const { success, message } = response;

      if (success) {
        emit("report:reload");
        toast({ message: message, type: "success" });
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    })
    .finally(() => {
      showDelAvatar.value = false;
      onUpdate("header");
    });
}

const debounceUpdate = debounce(onUpdate, 500);

watch(
  () => props.report,
  (newReport) => {
    if (!newReport || mounted.value) return;

    payload.value = {
      ...payload.value,
      name: newReport.name || "",
      description: newReport.description || "",
      front_cover: {
        ...payload.value.front_cover,
        ...newReport.front_cover,
      },
      header: {
        ...payload.value.header,
        ...newReport.header,
      },
      footer: {
        ...payload.value.footer,
        ...newReport.footer,
      },
      summary: {
        ...payload.value.summary,
        ...newReport.summary,
      },
    };

    mounted.value = true;
  },
  { immediate: true },
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabList.value, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          key: item.key,
          class: _normalizeClass(["tab", {
            active: selectedTab.value === item.key,
          }]),
          onClick: ($event: any) => (selectedTab.value = item.key)
        }, _toDisplayString(item.label), 11, _hoisted_3))
      }), 128))
    ]),
    (selectedTab.value === 'content')
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuList.value, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.key,
                class: "menu",
                onClick: ($event: any) => (emit('click:menu', item.key))
              }, _toDisplayString(item.label), 9, _hoisted_6))
            }), 128))
          ])
        ]))
      : (selectedTab.value === 'report')
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(_unref(baseAccordion), {
              open: selectedAcc.value === 'infos',
              "header-padding-block": "0.5rem",
              "header-padding-inline": "0.75rem",
              "padding-block": "0",
              "padding-inline": "0",
              onOpen: _cache[4] || (_cache[4] = ($event: any) => (toggleAccordion('infos')))
            }, {
              title: _withCtx(() => [...(_cache[40] || (_cache[40] = [
                _createElementVNode("div", { class: "flex flex-row gap-1 items-center" }, [
                  _createElementVNode("span", { class: "uppercase font-bold" }, " Relatório ")
                ], -1)
              ]))]),
              content: _withCtx(() => [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_unref(baseInput), {
                    modelValue: payload.value.name,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((payload.value.name) = $event)),
                    value: payload.value.name,
                    background: "#fff",
                    onInput: _cache[1] || (_cache[1] = ($event: any) => (_unref(debounceUpdate)('name')))
                  }, {
                    label: _withCtx(() => [...(_cache[41] || (_cache[41] = [
                      _createTextVNode(" Nome * ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["modelValue", "value"]),
                  _createVNode(_unref(baseTextarea), {
                    modelValue: payload.value.description,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((payload.value.description) = $event)),
                    value: payload.value.description,
                    onInput: _cache[3] || (_cache[3] = ($event: any) => (_unref(debounceUpdate)('description')))
                  }, {
                    label: _withCtx(() => [...(_cache[42] || (_cache[42] = [
                      _createTextVNode(" Descrição ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["modelValue", "value"])
                ])
              ]),
              _: 1
            }, 8, ["open"]),
            _createVNode(_unref(baseAccordion), {
              open: selectedAcc.value === 'front_cover',
              "header-padding-block": "0.5rem",
              "header-padding-inline": "0.75rem",
              "padding-block": "0",
              "padding-inline": "0",
              onOpen: _cache[15] || (_cache[15] = ($event: any) => (toggleAccordion('front_cover')))
            }, {
              title: _withCtx(() => [...(_cache[43] || (_cache[43] = [
                _createElementVNode("div", { class: "flex flex-row gap-1 items-center" }, [
                  _createElementVNode("span", { class: "uppercase font-bold" }, " Capa ")
                ], -1)
              ]))]),
              content: _withCtx(() => [
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_unref(baseSelect), {
                    modelValue: payload.value.front_cover.visible,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((payload.value.front_cover.visible) = $event)),
                    value: payload.value.front_cover.visible,
                    options: showOptions.value,
                    "is-empty": false,
                    required: "",
                    onChange: _cache[6] || (_cache[6] = ($event: any) => (onUpdate('front_cover')))
                  }, {
                    label: _withCtx(() => [...(_cache[44] || (_cache[44] = [
                      _createTextVNode(" Exibir Capa? ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["modelValue", "value", "options"]),
                  _createVNode(_unref(baseSelect), {
                    modelValue: payload.value.front_cover.font_family,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((payload.value.front_cover.font_family) = $event)),
                    value: payload.value.front_cover.font_family,
                    height: "32px",
                    "is-empty": false,
                    options: optionsFonts.value,
                    onChange: _cache[8] || (_cache[8] = ($event: any) => (onUpdate('front_cover')))
                  }, {
                    label: _withCtx(() => [...(_cache[45] || (_cache[45] = [
                      _createTextVNode(" Estilo de Fonte ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["modelValue", "value", "options"]),
                  _createVNode(_unref(baseSelect), {
                    modelValue: payload.value.front_cover.size,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((payload.value.front_cover.size) = $event)),
                    value: payload.value.front_cover.size,
                    height: "32px",
                    "is-empty": false,
                    options: optionsFontSize.value,
                    onChange: _cache[10] || (_cache[10] = ($event: any) => (onUpdate('front_cover')))
                  }, {
                    label: _withCtx(() => [...(_cache[46] || (_cache[46] = [
                      _createTextVNode(" Tamanho ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["modelValue", "value", "options"]),
                  _createVNode(_unref(baseSelect), {
                    modelValue: payload.value.front_cover.align,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((payload.value.front_cover.align) = $event)),
                    value: payload.value.front_cover.align,
                    height: "32px",
                    "is-empty": false,
                    options: optionsAlign.value,
                    onChange: _cache[12] || (_cache[12] = ($event: any) => (onUpdate('front_cover')))
                  }, {
                    label: _withCtx(() => [...(_cache[47] || (_cache[47] = [
                      _createTextVNode(" Alinhamento ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["modelValue", "value", "options"]),
                  _createVNode(_unref(baseTextEditor), {
                    modelValue: payload.value.front_cover.text,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((payload.value.front_cover.text) = $event)),
                    floating: false,
                    selected: true,
                    style: {
                  'font-size': '16px',
                },
                    onUpdate: _cache[14] || (_cache[14] = ($event: any) => (onUpdateEditor('front_cover', 'text', $event)))
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _: 1
            }, 8, ["open"]),
            _createVNode(_unref(baseAccordion), {
              open: selectedAcc.value === 'summary',
              "header-padding-block": "0.5rem",
              "header-padding-inline": "0.75rem",
              "padding-block": "0",
              "padding-inline": "0",
              onOpen: _cache[22] || (_cache[22] = ($event: any) => (toggleAccordion('summary')))
            }, {
              title: _withCtx(() => [...(_cache[48] || (_cache[48] = [
                _createElementVNode("div", { class: "flex flex-row gap-1 items-center" }, [
                  _createElementVNode("span", { class: "uppercase font-bold" }, " Índice ")
                ], -1)
              ]))]),
              content: _withCtx(() => [
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_unref(baseSelect), {
                    modelValue: payload.value.summary.visible,
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((payload.value.summary.visible) = $event)),
                    value: payload.value.summary.visible,
                    options: showOptions.value,
                    "is-empty": false,
                    required: "",
                    onChange: _cache[17] || (_cache[17] = ($event: any) => (onUpdate('summary')))
                  }, {
                    label: _withCtx(() => [...(_cache[49] || (_cache[49] = [
                      _createTextVNode(" Exibir Resumo? ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["modelValue", "value", "options"]),
                  _createVNode(_unref(baseSelect), {
                    modelValue: payload.value.summary.font_family,
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((payload.value.summary.font_family) = $event)),
                    value: payload.value.summary.font_family,
                    height: "32px",
                    "is-empty": false,
                    options: optionsFonts.value,
                    onChange: _cache[19] || (_cache[19] = ($event: any) => (onUpdate('summary')))
                  }, {
                    label: _withCtx(() => [...(_cache[50] || (_cache[50] = [
                      _createTextVNode(" Estilo de Fonte ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["modelValue", "value", "options"]),
                  _createVNode(_unref(baseSelect), {
                    modelValue: payload.value.summary.size,
                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((payload.value.summary.size) = $event)),
                    value: payload.value.summary.size,
                    height: "32px",
                    "is-empty": false,
                    options: optionsFontSize.value,
                    onChange: _cache[21] || (_cache[21] = ($event: any) => (onUpdate('summary')))
                  }, {
                    label: _withCtx(() => [...(_cache[51] || (_cache[51] = [
                      _createTextVNode(" Tamanho da Fonte ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["modelValue", "value", "options"])
                ])
              ]),
              _: 1
            }, 8, ["open"]),
            _createVNode(_unref(baseAccordion), {
              open: selectedAcc.value === 'header',
              "header-padding-block": "0.5rem",
              "header-padding-inline": "0.75rem",
              "padding-block": "0",
              "padding-inline": "0",
              onOpen: _cache[30] || (_cache[30] = ($event: any) => (toggleAccordion('header')))
            }, {
              title: _withCtx(() => [...(_cache[52] || (_cache[52] = [
                _createElementVNode("div", { class: "flex flex-row gap-1 items-center" }, [
                  _createElementVNode("span", { class: "uppercase font-bold" }, " Cabeçalho ")
                ], -1)
              ]))]),
              content: _withCtx(() => [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(_unref(baseAvatar), {
                      url: __props.report?.avatar?.base64,
                      "is-edit": true,
                      background: "#fff",
                      position: "right",
                      size: "6rem",
                      "border-radius": "0.5em",
                      onChange: changeAvatar,
                      onDel: _cache[23] || (_cache[23] = ($event: any) => (delAvatar()))
                    }, null, 8, ["url"])
                  ]),
                  _createVNode(_unref(baseSelect), {
                    modelValue: payload.value.header.visible,
                    "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((payload.value.header.visible) = $event)),
                    value: payload.value.header.visible,
                    options: showOptions.value,
                    "is-empty": false,
                    required: "",
                    onChange: _cache[25] || (_cache[25] = ($event: any) => (onUpdate('header')))
                  }, {
                    label: _withCtx(() => [...(_cache[53] || (_cache[53] = [
                      _createTextVNode(" Exibir Cabeçalho? ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["modelValue", "value", "options"]),
                  _createVNode(_unref(baseTextarea), {
                    modelValue: payload.value.header.title,
                    "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((payload.value.header.title) = $event)),
                    value: payload.value.header.title,
                    onInput: _cache[27] || (_cache[27] = ($event: any) => (_unref(debounceUpdate)('header')))
                  }, {
                    label: _withCtx(() => [...(_cache[54] || (_cache[54] = [
                      _createTextVNode(" Título ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["modelValue", "value"]),
                  _createVNode(_unref(baseTextarea), {
                    modelValue: payload.value.header.subtitle,
                    "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((payload.value.header.subtitle) = $event)),
                    value: payload.value.header.subtitle,
                    onInput: _cache[29] || (_cache[29] = ($event: any) => (_unref(debounceUpdate)('header')))
                  }, {
                    label: _withCtx(() => [...(_cache[55] || (_cache[55] = [
                      _createTextVNode(" Subtítulo ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["modelValue", "value"])
                ])
              ]),
              _: 1
            }, 8, ["open"]),
            _createVNode(_unref(baseAccordion), {
              open: selectedAcc.value === 'footer',
              "header-padding-block": "0.5rem",
              "header-padding-inline": "0.75rem",
              "padding-block": "0",
              "padding-inline": "0",
              onOpen: _cache[37] || (_cache[37] = ($event: any) => (toggleAccordion('footer')))
            }, {
              title: _withCtx(() => [...(_cache[56] || (_cache[56] = [
                _createElementVNode("div", { class: "flex flex-row gap-1 items-center" }, [
                  _createElementVNode("span", { class: "uppercase font-bold" }, " Rodapé ")
                ], -1)
              ]))]),
              content: _withCtx(() => [
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_unref(baseSelect), {
                    modelValue: payload.value.footer.visible,
                    "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((payload.value.footer.visible) = $event)),
                    value: payload.value.footer.visible,
                    options: showOptions.value,
                    "is-empty": false,
                    required: "",
                    onChange: _cache[32] || (_cache[32] = ($event: any) => (onUpdate('footer')))
                  }, {
                    label: _withCtx(() => [...(_cache[57] || (_cache[57] = [
                      _createTextVNode(" Exibir Rodapé? ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["modelValue", "value", "options"]),
                  _createVNode(_unref(baseTextarea), {
                    modelValue: payload.value.footer.title,
                    "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((payload.value.footer.title) = $event)),
                    value: payload.value.footer.title,
                    onInput: _cache[34] || (_cache[34] = ($event: any) => (_unref(debounceUpdate)('footer')))
                  }, {
                    label: _withCtx(() => [...(_cache[58] || (_cache[58] = [
                      _createTextVNode(" Título ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["modelValue", "value"]),
                  _createVNode(_unref(baseTextarea), {
                    modelValue: payload.value.footer.subtitle,
                    "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((payload.value.footer.subtitle) = $event)),
                    value: payload.value.footer.subtitle,
                    onInput: _cache[36] || (_cache[36] = ($event: any) => (_unref(debounceUpdate)('footer')))
                  }, {
                    label: _withCtx(() => [...(_cache[59] || (_cache[59] = [
                      _createTextVNode(" Subtítulo ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["modelValue", "value"])
                ])
              ]),
              _: 1
            }, 8, ["open"])
          ]))
        : _createCommentVNode("", true),
    _createVNode(_unref(baseConfirm), {
      show: showDelAvatar.value,
      title: _unref(t)('common.labels.remove', { concat: _unref(t)('common.labels.avatar') }),
      message: 
        _unref(t)('common.texts.remove_message', { concat: _unref(t)('common.labels.avatar') })
      ,
      onCancel: _cache[38] || (_cache[38] = ($event: any) => (showDelAvatar.value = false)),
      onConfirm: _cache[39] || (_cache[39] = ($event: any) => (delAvatarConfirm()))
    }, null, 8, ["show", "title", "message"])
  ]))
}
}

})